var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('cpu-info',{staticClass:"px-1",attrs:{"show-title":false,"host":_vm.host}}),_c('cpu-chart',{staticClass:"mt-2"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }